import { render, staticRenderFns } from "./TextAutocomplete.vue?vue&type=template&id=b2bb14f4&"
import script from "./TextAutocomplete.vue?vue&type=script&lang=js&"
export * from "./TextAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports